module.exports = __webpack_public_path__ + "img/shade_quote.907c0c82.svg";